const state = {
	about: false,
	terms: false
}

const getters = {
	anyOpen: state => Object.values(state).some(Boolean)
}

const mutations = {
	show(state, modal) {
		state[modal] = true
	},
	hide(state, modal) {
		state[modal] = false
	}
}

export default {
	state,
	getters,
	mutations,
	namespaced: true
}
